module.exports = __webpack_public_path__ + "static/media/birkbeck.3aa77204.jpg";